export default {
  freePriceNote: "Free only when ordering paid services",
  owner: {
    jobTitleMobileDev: 'Cross-platform mobile app developer',
    jobTitleWebDev: 'Full stack web developer',

    /* Services localizations */
    serviceFlutter: "Flutter development",
    serviceDescFlutter: "I build your amazing mobile application that works on Android and IOS, with a gorgeous design and fluid performance. They'll be seduced.",
    serviceBackend: "Back-end and API development",
    serviceDescBackend: "You have an application and you need an API to manage the data generated by this app. You're in the right place.",
    serviceFrontend: "Front-end development",
    serviceDescFrontend: "The UI is what speaks to your users and customers. Hire this service to have a front-end that speaks to your users and that I can connect to your existing API if necessary.",
    serviceFirebase: "Firebase integration",
    serviceDescFirebase: "Full integration of Firebase into your website or mobile app. Going through data storage, hosting, crashlytics services, up to cloud functions and so on.",
    serviceMobileMoney: "Orange and MTN Mobile Money payment",
    serviceDescMobileMoney: "The Mobile money allows you to receive payments from those who don't have a bank account. I add these payment methods to your app or website.",
    serviceMaps: "Maps integration",
    serviceDescMaps: "Tracking on a map, route plotting, positioning alert, geolocation, real time positioning monitoring.",
    serviceSockets: "Real time and push notification integration",
    serviceDescSockets: "You have an application or a website but you want someone to integrate a real-time data feed, for example a chat functionality or any other. Add a push notifications to notify your users that something has happened in the app. You are welcome.",
    /* End Services localizations */

    thingBuildMobileApp: "Ios and android applications",
    thingBuildBackend: "Applications back-end and restful api",
    thingBuildDesktop: "Desktop applications",
    thingBuildWeb: "Web applications",
    thingBuildLaravelDepTools: "Laravel deployment tools",

    pricePlanItemSpecifications: "Make specifications",
    pricePlanItemMilestones: "Milestones advice",
    pricePlanItemMobile: "Mobile app development",
    pricePlanItemBackend: "Backend / API development",
    pricePlanItemFrontend: "Frontend development",
    pricePlanItemWeb: "Website development",
    pricePlanItemDesktop: "Desktop development",
  },
  labels: {
    french: "French",
    english: "English",
    downloadCv: "Download CV",
    myServices: "My Services",
    yearsExperience: "Years Experience",
    completedProjects: "Completed Projects",
    happyCustomers: "Happy Customers",
    honorsAndAwards: "Honors and Awards",
    iBuild: "I build",
    pricePlans: "Price Plans",
    startingFrom: "Starting from",
    free: "Free",
    starterPlan: "Starter plan",
    specificTasksPlan: "For specific tasks",
    fullTimePlan: "Full time",
    githubRepo: "See the code on Github"
  },
  intros: {
    home: "Discover how I Help<br/>Make your <span style='text-decoration: line-through'>idea</span> Dream Comes True!"
  }
}
